import { useMemo } from 'react'
import { RRule } from 'rrule'
import { parseISO } from 'date-fns'

const expandEvent = (event, rangeStart, rangeEnd) => {
  const ruleStr = event.recurrence_rule
  if (!ruleStr) return [event]

  try {
    const dtstart = parseISO(event.start_time)
    const rule = RRule.fromString(`DTSTART:${dtstart.toISOString().replace(/[-:]/g, '').split('.')[0]}Z\nRRULE:${ruleStr}`)

    const duration = event.end_time
      ? parseISO(event.end_time) - dtstart
      : 0

    const occurrences = rule.between(
      new Date(rangeStart),
      new Date(rangeEnd),
      true,
    )

    return occurrences.map((date) => ({
      ...event,
      _occurrence: true,
      _originalId: event.id,
      id: `${event.id}_${date.toISOString()}`,
      start_time: date.toISOString(),
      end_time: event.end_time ? new Date(date.getTime() + duration).toISOString() : null,
    }))
  } catch {
    return [event]
  }
}

export const useExpandedEvents = (eventsData, rangeStart, rangeEnd, hiddenIds) => {
  return useMemo(() => {
    if (!eventsData) return []

    const { nonRecurring = [], recurring = [] } = eventsData

    const filtered = (events) =>
      events.filter((e) => !hiddenIds.has(e.calendar_id))

    const expanded = filtered(recurring).flatMap((e) =>
      expandEvent(e, rangeStart, rangeEnd),
    )

    return [...filtered(nonRecurring), ...expanded]
  }, [eventsData, rangeStart, rangeEnd, hiddenIds])
}
